import {
  createProgressAdapter,
  createMemoryBackend,
} from '../game/progress.js';

/** @type {ReturnType<typeof createProgressAdapter> | null} */
let adapter = null;

export function getStorage() {
  if (adapter) return adapter;
  const mem = createMemoryBackend();
  const ls =
    typeof globalThis.localStorage !== 'undefined'
      ? globalThis.localStorage
      : mem;
  adapter = createProgressAdapter(ls, {
    onWarning: () => {
      const ev = new CustomEvent('glifo-storage-warning');
      globalThis.dispatchEvent(ev);
    },
  });
  return adapter;
}

export function loadAppProgress() {
  return getStorage().load();
}

export function saveAppProgress(p) {
  getStorage().save(p);
}
